import { createI18n } from 'vue-i18n'
import CN from '@/locales/cn.json' // 中文
import EN from '@/locales/en.json' // 英文
import JA from '@/locales/ja.json' // 日文
import CANTONESE from '@/locales/cantonese.json' // 粤语
import ES from '@/locales/es.json' // 西班牙语
import KO from '@/locales/ko.json' // 韩语
import TH from '@/locales/th.json' // 泰语

// 确保所有语言包都包含必要的键
const messages = {
  cn: CN,
  en: EN,
  ja: JA,
  cn_cantonese: CANTONESE,
  es: ES,
  ko: KO,
  th: TH
}

// 支持的语言代码映射（处理可能的语言代码变体）
const languageMap: Record<string, string> = {
  en: 'en',
  cn: 'cn',
  ja: 'ja',
  cn_cantonese: 'cn_cantonese',
  es: 'es',
  ko: 'ko',
  th: 'th'
}

const i18n = createI18n({
  legacy: false, // 必须设置为false，才能使用Composition API
  locale: 'en', // 默认语言
  fallbackLocale: 'en', // 备用语言
  globalInjection: true, // 全局注入$t方法
  messages,
  missingWarn: false, // 禁用缺失键警告（因为我们已经确保所有键都存在）
  fallbackWarn: false // 禁用回退警告
})

// 导出语言映射函数，供外部使用
export function normalizeLanguage(lang: string): string {
  return languageMap[lang.toLowerCase()] || lang.toLowerCase() || 'en'
}

export default i18n
